module.exports = __webpack_public_path__ + "img/mynews24-middle.749784a8.png";